export default function setZipAction(zip) {
return {
    type: 'SET_ZIP',
    payload: zip
}
}